import { z } from 'zod';

import { type SelectCompanyRequest, type SelectCompanyResponse } from './select-company.dto.js';
import { UserAuthTokensResponseSchema } from './session.schema.js';

export const SelectCompanyRequestSchema: z.ZodType<SelectCompanyRequest> = z
  .object({
    companyId: z.uuid(),
  })
  .strict();

export const SelectCompanyResponseSchema: z.ZodType<SelectCompanyResponse> =
  UserAuthTokensResponseSchema;
